import React, { FC } from 'react'
import classNamesBind from 'classnames/bind'

import { Profile } from '@dashboard/lib/types'
import {
  getTitle,
  getDescription,
  getDescriptionGeneric,
} from '@dashboard/lib/enneagram'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  type: string
  rank: number
  profile?: Profile
  useEnneagramColor?: boolean
  useBasicColor?: boolean
}

const TypeRank: FC<OwnProps> = ({
  type,
  rank,
  profile,
  useEnneagramColor,
  useBasicColor,
}: OwnProps) => {
  let primaryType = profile?.personality?.disc_type || 'empty'
  if (useEnneagramColor) primaryType = `enneagram-${type}`
  if (useBasicColor) primaryType = 'empty'

  // Functions
  const getPlaceText = (index: number): string => {
    if (index == 1) return 'st'
    if (index == 2) return 'nd'
    if (index == 3) return 'rd'
    return 'th'
  }

  return (
    <div className={classNames('type-rank')}>
      <div className={classNames('ranking', primaryType)}>
        {rank}
        <span className={classNames('ranking-tail')}>{getPlaceText(rank)}</span>
      </div>
      Type: {type} - The {getTitle(type)}
      <div className={classNames('type-description')}>
        {profile ? getDescription(type, profile) : getDescriptionGeneric(type)}
      </div>
    </div>
  )
}

export default TypeRank
